import memoizee from "memoizee";
import * as m from "qpr-base/api/model";

export const getPeriodLevels = memoizee(
  async (modelId: string) =>
    (await m.getPeriodLevels(modelId)).sort(
      (a, b) =>
        parseInt(b.periodleveltype, 10) - parseInt(a.periodleveltype, 10)
    ),
  {
    //promise: true,
  }
);
